import { PerformanceContainer } from '../../organisms/performance';

export const PerformanceAnalysis = () => <PerformanceContainer />;
